/* eslint-disable @typescript-eslint/no-redeclare */
import React, { useEffect } from 'react';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ToastMessage {


    message: string,
    status: string


}
const ToastMessage: React.FC<ToastMessage> = ({ message, status }) => {

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const notify = () => {

        // @ts-ignore
        toast[status](message)
    };

    useEffect(() => {


        if (status && message) {
            notify()
        }
    }, [message, notify, status])

    return (
        <div>

            <ToastContainer />
        </div>
    );
}
export default ToastMessage;
